export const ItemTypes = {
  CHOICE_IMAGE: 'choiceImage',
};